import React, { useEffect, useState } from 'react';
import HorizontalStack from 'Components/ComponentLibrary/Atoms/Layout/HorizontalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import Container from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Container';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WhatIfClientDisclaimer from 'Components/ComponentLibrary/Organisms/WhatIfClientDisclaimer';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { WhatIfScenarioAssumptionsClientDisclaimer } from 'Components/ComponentLibrary/Organisms/WhatIfScenarioAssumptionsClientDisclaimer/';
import InsightContent from './InsightContent';

const useStyles = buildUseStyles('FacetPlanClientScenarioInsightTemplate', (theme) => ({
  container: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));

const FacetPlanClientScenarioInsightTemplate = () => {
  const [disclaimer, setDisclaimer] = useState();
  const classes = useStyles();

  const {
    pageContentCollection,
    pageContentResource,
  } = usePageContentContext();

  async function getClientDisclaimer() {
    const [clientDisclaimer] = await pageContentResource.relationship(fr.relationships.clientDisclaimer.name).link('related').get();
    setDisclaimer(clientDisclaimer);
  }

  useEffect(() => {
    getClientDisclaimer();
  }, [pageContentResource]);


  return (
    <VerticalStack height="open" spacing={2}>
      <StackItem>
        {/* -------- Main Header bar w/ Navigation -------- */}
        <HeaderBar
          title={'Scenario Selection'}
        />
      </StackItem>
      <StackItem>
        <Container maxWidth="xl" className={classes.container}>
          <HorizontalStack justify="center" spacing={3} wrap>
            {pageContentCollection.resources().list().map((insight, index) => (
              <StackItem key={insight.id()}>
                <InsightContent resource={insight} index={index} />
              </StackItem>
            ))}
          </HorizontalStack>
        </Container>
      </StackItem>
      <StackItem maxWidth="md">
        <Container maxWidth="sm">
          <WhatIfScenarioAssumptionsClientDisclaimer resource={pageContentResource} />
          <Box marginBottom={3}>
            {disclaimer ? <WhatIfClientDisclaimer resource={disclaimer} /> : null}
          </Box>
        </Container>
      </StackItem>
    </VerticalStack>
  );
};

FacetPlanClientScenarioInsightTemplate.defaultProps = {};

FacetPlanClientScenarioInsightTemplate.propTypes = {};

export default FacetPlanClientScenarioInsightTemplate;
